import { PortalTemplate } from "../../../template/portal/default-template";
import { TtzkPortalR } from "../route";
import { Redirect, useHistory } from "react-router-dom";
import { useAuthContextV2 } from "../../../../auth-state";
import apiClient from "../../../../application/apis/api-client";
import { toast } from "react-toastify";
import { reportTtzkPortalRelatedError } from "../../../../application/domain/ttzk-portal/util/error";
import { NoticeForm } from "../../../organisms/ttzk-portal/notice-form";

export type NoticeRequest = {
  organizationId: string;
  title: string;
  content: string;
  isHighlighted: boolean;
  isPublished: boolean;
  publishDate: string;
};

export const NoticeCreate = () => {
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 9 + 1); //Asia/Tokyoタイムゾーンの1時間後をデフォルトにする
  const { auth } = useAuthContextV2();
  const history = useHistory();
  const initialNotice = {
    organizationId: auth.data?.orgId ?? "",
    title: "",
    content: "",
    isHighlighted: false,
    isPublished: false,
    publishDate: currentDate.toISOString().slice(0, 16),
  };

  if (!auth.hasPermissions("portal.notices.create")) {
    return <Redirect to={TtzkPortalR.Home.link({})} />;
  }

  const onSave = async (notice: NoticeRequest) => {
    try {
      const { data } = await apiClient.ttzkPortal.createNotice(notice);
      toast.success("お知らせ情報を新規作成しました。");
      history.push(TtzkPortalR.NoticeEdit.link({ noticeId: data.id }));
    } catch (error) {
      reportTtzkPortalRelatedError(error);
      const message = error.response?.data?.msg ?? error.message;
      toast.error(
        `お知らせ情報の新規作成に失敗しました。error message: ${message}`,
      );
    }
  };

  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: TtzkPortalR.NoticeList.link({}), title: "お知らせ情報一覧" },
        {
          to: TtzkPortalR.NoticeCreate.link({}),
          title: "お知らせ情報の新規作成",
        },
      ]}
    >
      <div className={"content"}>
        <h1>お知らせ情報の新規作成</h1>
        <hr />
        <NoticeForm
          initialNotice={initialNotice}
          onSave={onSave}
          submitLabel={"上記の内容でお知らせ情報を新規作成する"}
        />
      </div>
    </PortalTemplate>
  );
};
